import { Autocomplete, TextField, SxProps, Theme } from "@mui/material";
import { useState, useEffect } from "react";
import { planoAcaoService } from "../services/PlanoAcaoService";
import PlanoAcao from "../types/negocio/PlanoAcao";

interface SelectAcaoProps {
  value: PlanoAcao | null;
  onChange: (value: PlanoAcao | undefined) => void;
  label?: string;
  sx?: SxProps<Theme>;
}

const SelectAcao = ({
  value,
  onChange,
  label = "Pesquisar Ação",
  sx = { flexGrow: 1 }
}: SelectAcaoProps) => {
  const [acoes, setAcoes] = useState<PlanoAcao[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    planoAcaoService
      .listarTodos()
      .then((data) => {
        // filtra apenas os planos que não estejam arquivados
        const arquivados = data.filter((acao: PlanoAcao) => acao.arquivado === false);
        setAcoes(arquivados);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <Autocomplete
      options={acoes}
      value={value}
      onChange={(_, newValue) => onChange(newValue ?? undefined)}
      getOptionLabel={(option) => option.acao}
      renderInput={(params) => (
        <TextField {...params} label={label} variant="outlined" />
      )}
      clearOnEscape
      noOptionsText="Nenhuma ação encontrada"
      sx={sx}
      loading={loading}
    />
  );
};

export default SelectAcao;
